<template>
  <form
    class="form-wrap"
    @submit.prevent="handleSubmit"
  >
    <div class="form-wrap__form">
      <slot />
    </div>
    <div
      v-if="$slots.actions"
      class="form-wrap__actions--custom"
    >
      <slot name="actions" />
    </div>
    <div
      v-if="shouldShowDefaultActions && !$slots.actions"
      class="form-wrap__actions--default"
    >
      <button-input
        v-t="'c.formWrap.form.action.submit'"
        :is-disabled="isDisabled"
        class="form-wrap__submit"
        type="submit"
      />
      <button-input
        v-t="'c.formWrap.form.action.cancel'"
        class="form-wrap__cancel"
        @click="handleCancel"
      />
    </div>
  </form>
</template>

<script>
import ButtonInput from '@/components/ui/ButtonInput'

export default {
  name: 'FormWrap',
  components: {
    ButtonInput
  },
  props: {
    isDisabled: {
      type: Boolean,
      default: () => false
    },
    shouldShowDefaultActions: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    handleSubmit (event) {
      if (!this.isDisabled) {
        this.$emit('submit')
      }
    },
    handleCancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="sass">
@import '~styles/imports'

.form-wrap .col-xl-6
  &:first-child
    padding-left: 0

    +respond-max($xl)
      padding-right: 0

  &:last-child
    padding-right: 0

    +respond-max($xl)
      padding-left: 0
</style>



// WEBPACK FOOTER //
// src/components/forms/FormWrap.vue